<template>
    <section class="slice slice-trends-headlines" :class="{'slice-trends-headlines--grey': backgroundColor === 'grey'}">
        <div class="slice-content">
            <div class="slice-trends-headlines__columns">
                <div v-for="(headline, i) in props.slice.primary.headlines" :key="`headline-${i}`" class="slice-trends-headlines__column">
                    <div class="slice-trends-headlines__head">
                        <VJoyIcon name="heart-path" size="small" />
                        <span>{{ headline.title }}</span>
                    </div>
                    <PrismicRichText :field="headline.description" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {Content} from '@prismicio/client';
    import {getSliceComponentProps} from '@prismicio/vue';
    import {PrismicRichText} from '@prismicio/vue';
    import {VJoyIcon} from '@maltjoy/core-vue';

    const props = defineProps(getSliceComponentProps<Content.TrendsHeadlinesSlice>(['slice', 'index', 'slices', 'context']));
    const backgroundColor = computed(() => props.slice.primary.backgroundColor);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .slice-trends-headlines {
        &--grey {
            background-color: var(--joy-color-neutral-20);
        }

        .slice-content {
            @include mq.screen_md(min) {
                padding-top: var(--joy-core-spacing-1Z);
            }
        }

        &__columns {
            display: flex;
            flex-direction: column;
            gap: var(--joy-core-spacing-4);

            @include mq.screen_md(min) {
                flex-direction: row;
            }
        }
        &__column {
            padding-top: var(--joy-core-spacing-4);

            &:not(:first-child) {
                border-top: 1px solid var(--joy-color-text-heading);
            }

            @include mq.screen_md(min) {
                flex: 1;
                padding-top: 0;

                &:not(:first-child) {
                    border-top: none;
                    padding-left: var(--joy-core-spacing-4);
                    border-left: 1px solid var(--joy-color-text-heading);
                }
            }
        }
        // &__column:not(:first-child) {
        //     // padding-top: var(--joy-core-spacing-4);
        //     // border-top: 1px solid var(--joy-color-text-heading);

        //     @include mq.screen_md(min) {
        //         padding-top: 0;
        //         border-top: none;
        //         padding-left: var(--joy-core-spacing-4);
        //         border-left: 1px solid var(--joy-color-text-heading);
        //     }
        // }

        &__head {
            display: flex;
            align-items: center;
            gap: var(--joy-core-spacing-3);
            @include text.getFontBySize(primary-600);
            font-weight: var(--joy-font-weight-bold);
            margin-bottom: var(--joy-core-spacing-3);

            i {
                color: var(--joy-color-text-heading);
                position: relative;
                top: 1px;
            }
        }
    }
</style>
